/* React Higher Order Component which fetches activity lock data for activity where activityId = props.activityId. Lock data will refresh via poll and pass changes via props
    Child (InnerComponent) will only render once activity data is successfully fetched.
    child will receive props: {
        activityLock: PropTypes.object
        onToggleActivityLockPoll: PropTypes.func
    }

*/

import React from 'react';
import PropTypes from 'prop-types';

const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const ReactUtil = require('../../util/ReactUtil');
import LoadingMainContent from '../loading/LoadingMainContent';

const propTypes = {
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelStoreState: PropTypes.shape({ channel: PropTypes.shape({ user_permissions: PropTypes.object.isRequired }) }).isRequired,
    projectStoreState: PropTypes.shape({ project: PropTypes.shape({ user_permissions: PropTypes.object.isRequired }) }).isRequired,
    documentVisible: PropTypes.bool.isRequired,
    hideLoadingIcon: PropTypes.bool,
};

const defaultProps = {
    hideLoadingIcon: false,
};

const POLL_ACTION_ID = 'activity-lock-poll';

export default function withActivityLockPoll(WrappedComponent) {
    class WithActivityLockPoll extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                activityLock: ActivityStore.getStateActivity(
                    props.activityId,
                    props.projectStoreState.project.id,
                    props.channelStoreState.channel.id
                    ).activityLock,
                devDisablePolling: false,
                fatalError: null
            }

            this.refreshLockData = this.refreshLockData.bind(this);
            this.onTogglePolling = this.onTogglePolling.bind(this);
            this.unsubscribes = [ActivityStore.listen(this.onActivityStoreChange.bind(this))];
        }

        UNSAFE_componentWillMount() {
            const self = this;
            this.refreshLockData(true);
            this.updateLockInterval = window.setInterval(self.refreshLockData, 10000);
        }

        componentWillUnmount() {
            window.clearInterval(this.updateLockInterval);
            this.unsubscribes.forEach(u => u());
        }

        onActivityStoreChange(newState) {
            if (newState.action.id === POLL_ACTION_ID) {
                this.setState({
                    activityLock: ActivityStore.getStateActivity(
                        this.props.activityId,
                        this.props.projectStoreState.project.id,
                        this.props.channelStoreState.channel.id
                        ).activityLock,
                });
            }
        }

        refreshLockData(init=false) {
            if (
                !init // ignore all other visibilty/poll disabled when fetching for the first time
                && (!this.props.documentVisible || this.state.devDisablePolling)
            ) {
                return;
            }

            const project = this.props.projectStoreState.project;
            const channel = this.props.channelStoreState.channel;
            if (!project || !channel || !PermissionsUtil.canViewActivities(channel.user_permissions, project.user_permissions)) {
                return;
            }

            ActivityActions.getActivityLockStatus(
                POLL_ACTION_ID,
                {
                    activityId: this.props.activityId,
                    projectId: this.props.projectStoreState.project.id
                }
            );
        }

        onTogglePolling(disableBool) {
            this.setState({ devDisablePolling: disableBool });
        }

        render() {
            if (!this.state.activityLock) { // wait until activity lock data is known before rendering children
                if (this.props.hideLoadingIcon) {
                    return null;
                }
                else {
                    return <LoadingMainContent />;
                }
            }

            return (
                <WrappedComponent
                    {...this.props}
                    activityLock={this.state.activityLock}
                    onToggleActivityLockPoll={this.onTogglePolling}
                />
            );
        }
    }

    WithActivityLockPoll.propTypes = propTypes;
    WithActivityLockPoll.defaultProps = defaultProps;
    WithActivityLockPoll.displayName = `WithActivityLockPoll(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithActivityLockPoll;
}
